import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const HEADERLINKBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "link_url",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  headerLinkBlockDescriptor: _generatedHeaderLinkBlockDescriptor,
  headerLinkBlockBlocDefinition,
  headerLinkBlockDashboardLayout,
  headerLinkBlockConfig,
  headerLinkBlockResolveConfig,
  headerLinkBlockProperties,
} = doodBlockConfig(
  {
    name: "Header - Link",
    componentType: "HeaderLinkBlockComponent",
    category: "navigation",
    description: "Header - Link.",
    keywords: [],
    allowedIn: [
      { bloc: "HeaderBlockComponent", slot: "left_blocks" },
      { bloc: "HeaderBlockComponent", slot: "right_blocks" },
    ],
    sharedFields: {},
  },

  () => ({
    label: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.header-link.label.label",
      },
    }),
    link_url: propertyValue({
      type: "link",
      value: "",
      options: {
        label: "pages.blocks.header-link.link-url.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.header-link.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.header-link.fieldset.link.label",
            fields: ["label", "link_url"],
          },
        ],
      },
    ],
  }),
);

export function headerLinkBlockDescriptor(): IBlockDescriptor;
export function headerLinkBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function headerLinkBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeaderLinkBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedHeaderLinkBlockDescriptor,
    headerLinkBlockProperties,
    fieldOrder,
  );
}

export {
  headerLinkBlockBlocDefinition,
  headerLinkBlockDashboardLayout,
  headerLinkBlockProperties,
  headerLinkBlockConfig,
  headerLinkBlockResolveConfig,
};

export type HeaderLinkBlockConfig = typeof headerLinkBlockConfig;
